import { render, staticRenderFns } from "./DeleteConfirmButton.vue?vue&type=template&id=25d7e010&"
import script from "./DeleteConfirmButton.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports